<template>
  <div class="page dfts" :style="bgimg">
    
    <div class="dfts-home" v-if="curretTabName === 'home'">
      <div class="dfts-map" :style="mapSize" @click="changeTab(0)">
      </div>
      <div class="tab-title">
        <img :src="title">
      </div>
      <div class="intro-mask">
        <div class="btn-dialog btn-dialog-show" @click="intro = true">{{ $t("page.dfts.intro") }}</div>
      </div>
      <transition name="slide-fade">
        <div class="home-intro" v-if="intro">
          <img class="intro-title" src="img/dfts/home-intro-tt.png">
          <m-textarea>
            <div v-html="content"></div>
          </m-textarea>
          <div class="btn-dialog" @click="intro = false">{{ $t("base.pack-up") }}</div>
        </div>
      </transition>
    </div>

    <div class="dfts-tabs" v-else>
      <div class="tab-title">
        <img :src="title">
      </div>
      <m-textarea>
        <div :class="lngClass" v-html="content"></div>
      </m-textarea>
      <div class="btn-dialog btn-dialog-show" @click="subMenn = true">{{ $t("page.dfts.other") }}</div>
    </div>
    <transition name="submenu-slide">
      <div class="submenu-wrapper" :class="lngClass" v-if="subMenn">
        <div class="dfts-menu">
          <div class="submenu-main">
            <div
              :class="['dfts-tabnav', {active: currentTab === index}]"
              v-for="(item, index) in tabs"
              :key="index"
              @click="changeTab(index)"
            >
              <div class="icon"></div>
              <span>{{ $t(`tabs.${page}.${item.name}`) }}</span>
            </div>
          </div>
          <div class="btn-dialog" @click="subMenn = false">{{ $t("base.pack-up") }}</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import TextArea from "@/components/TextArea.vue";
import BottomNav from "@/components/BottomNav.vue";

export default {
  components: {
    "m-textarea": TextArea,
    BottomNav
  },
  data() {
    return {
      page: "dfts",
      currentTab: -1,
      curretTabName: "home",
      intro: false,
      subMenn: false
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.dfts,
      dfts: "dfts"
    }),
    ...mapGetters(["lngClass"]),
    bgimg() {
      if (this.curretTabName != "home") {
        const bgimg = "img/dfts/dfts-bg.jpg";
        return { backgroundImage: `url("${bgimg}")` };
      }
    },
    content() {
      const data = this.dfts[this.curretTabName];
      return data ? data.content : "";
    },
    title() {
      if (this.curretTabName === "home") {
        return "img/dfts/home-tt.png";
      } else {
        return this.tabs[this.currentTab].ttimg;
      }
    },
    mapSize() {
      const scale = window.innerWidth / 375;
      return { transform: `scale(${scale})`, transformOrigin: `left top` };
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: "home"
    });
  },
  methods: {
    ...mapActions(["getContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
      this.subMenn = false;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";

.dfts-home {
  position: relative;
  height: 100%;

  .tab-title {
    position: absolute;
    left: 1rem;
    top: 3rem;
    @include scaleimg(0.5);
  }

  .dfts-map {
    position: absolute;
    top: 0;
    width: 375px;
    height: 603px;
    background-image: url("~@/assets/img/map1.jpg");
    background-position-y: bottom;
    background-size: 100%;
  }

  .intro-mask {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 6rem;
    background: linear-gradient(
      rgba(242, 234, 210, 0),
      rgba(241, 234, 210, 0.8),
      rgba(241, 234, 210, 1)
    );
  }
}

.home-intro {
  @include full-box;
  padding-top: 6rem;
  padding-left: 2rem;
  padding-right: 1rem;
  background-image: url("~@/assets/img/dialog-bg.jpg");

  .intro-title {
    position: absolute;
    display: block;
    @include scaleimg(0.5);
  }

  .text-main {
    padding-left: 5rem;
    padding-right: 2rem;

    p {
      margin: 0;
    }
  }
}

.dfts-tabs {
  position: relative;
  height: 100%;
  padding-top: 3rem;
  padding-left: 5rem;
  padding-right: 2rem;

  .textarea {
    height: 65vh;
  }

  .text-main {
    padding: 0 0.5rem;
    font-size: 0.875rem;

    p {
      margin-top: 0;
      margin-bottom: 1rem;
    }

    @include title-h3(0.875rem);
    h3 {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      @include center-x;
    }

    .lng {
      h3 {
        font-weight: 500;
      }
    }
  }

  .tab-title {
    position: absolute;
    left: 1.5rem;
    top: 4rem;
    @include scaleimg(0.4);
  }

  @media (max-width: 320px) {
    .tab-title {
      transform: scale(0.35);
    }
  }
}

.submenu-wrapper {
  @include full-box;
  z-index: 500;
  padding: 5rem 2rem;
  background-color: rgba(0, 0, 0, 0.4);

  &.lng {
    padding: 5rem 1rem;
  }

  .dfts-menu {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 3rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    background-image: url("~@/assets/img/dialog-bg.jpg");
    background-size: 100%;
  }

  .submenu-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: space-around;
    flex-wrap: wrap;
    height: 17.5rem;
  }

  .dfts-tabnav {
    padding: 0 0.5rem;
    height: 2.5rem;

    .icon {
      display: inline-block;
      width: 0.75rem;
      height: 0.75rem;
      margin-right: 0.5rem;
      background-image: url("~@/assets/img/tab4-d.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }

    span {
      display: inline-block;
      line-height: 1.2;
    }

    &.active {
      color: $primary;

      .icon {
        background-image: url("~@/assets/img/tab4-a.png");
      }

      span::after {
        content: "";
        display: block;
        height: 1px;
        background-color: $primary;
      }
    }
  }

  .btn-dialog {
    bottom: 0.5rem;
  }
}

.btn-dialog {
  position: absolute;
  padding: 1rem;
  font-size: 0.875rem;
  background-image: url("~@/assets/img/arrow-down.png");
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 39px auto;
  @include center-x;

  &.btn-dialog-show {
    bottom: 1rem;
    background-image: url("~@/assets/img/arrow-up.png");
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active,
.submenu-slide-enter-active,
.submenu-slide-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}

.submenu-slide-enter-active,
.submenu-slide-leave-active {
  transition: all 0.3s ease;

  .dfts-menu {
    transition: all 0.2s linear;
  }
}

.submenu-slide-enter,
.submenu-slide-leave-to {
  opacity: 0;

  .dfts-menu {
    transform: translateY(300px);
  }
}
</style>
